import { render, staticRenderFns } from "./popover-picker.vue?vue&type=template&id=ecd03724&scoped=true"
import script from "./popover-picker.ts?vue&type=script&lang=ts&external"
export * from "./popover-picker.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd03724",
  null
  
)

export default component.exports